"use strict";
exports.__esModule = true;
exports.PAYMENT_TYPES = void 0;
exports.PAYMENT_TYPES = [
    'CASH',
    'BANK_CARD',
    'BANK_TRANSFER',
    'BALANCE_PAYMENT',
    'SPECIAL_DISCOUNT',
    'FACILITY',
    'PAY_AT_HOTEL',
];
//# sourceMappingURL=payment-types.constant.js.map